/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorState } from './monitorState';
import { ActionPerformer } from './actionPerformer';


export interface Monitor { 
    id?: string;
    state?: MonitorState;
    /**
     * Version of the monitor specification.
     */
    version?: string;
    monitor_name?: string;
    deployment_id?: string;
    /**
     * Monitor ID at the external tool (ASM).
     */
    external_monitor_id?: string;
    creation_attempted_by?: ActionPerformer;
    /**
     * Timestamp in UTC when the creation of the monitor was attempted.
     */
    creation_attempted_ts?: Date;
    /**
     * Timestamp in UTC when the monitor was updated.
     */
    last_updated_ts?: Date;
}
export namespace Monitor {
}


